
import { useEffect, useRef } from "react";

export default function GoogleOneTap({ onSuccess }) {
  const initialized = useRef(false);

  useEffect(() => {
    //  STOP if already logged in
    if (sessionStorage.getItem("user")) {
      if (window.google?.accounts?.id) {
        window.google.accounts.id.cancel();
      }
      return;
    }

    const clientIdMeta = document.querySelector(
      'meta[name="google-signin-client_id"]'
    );
    const clientId = clientIdMeta?.content;

    if (!clientId) {
      console.error("Missing google client_id meta tag");
      return;
    }

    const interval = setInterval(() => {
      if (window.google?.accounts?.id && !initialized.current) {
        clearInterval(interval);

        window.google.accounts.id.initialize({
          client_id: clientId,
          callback: onSuccess,
          auto_select: false,
          cancel_on_tap_outside: false,
        });

        window.google.accounts.id.prompt();

        initialized.current = true;
      }
    }, 300);

    return () => {
      clearInterval(interval);

      //  CLEANUP on unmount / route change
      if (window.google?.accounts?.id) {
        window.google.accounts.id.cancel();
      }
    };
  }, [onSuccess]);

  return null;
}  